import axios from "axios";
import baseURL from "../configs/api";

export const post_PaymentRequest = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}paymentRequest`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            userId
        }
    });
    return response.data;
}

export const put_PaymentRequestAsPaid = async (uniqeid: string, isReplaced: boolean) => {
    const response = await axios({
        url: `${baseURL}paymentRequest/UpdatePaymentRequestAsPaid?uniqeid=${uniqeid}&isReplaced${isReplaced}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
    });
    return response.data;
}

export const delete_PaymentRequest = async (primaryKey: number, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}paymentRequest`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: {
            id: primaryKey,
            userId
        }
    });
    return response.data;
}

export const getPaymentRequestsByReservationId = (reservationId: number, tenantId: string) => {
    return getFetch(`paymentRequest/GetPaymentRequestsByReservation/${reservationId}`, tenantId);
}

export const getReservationSummaryByPaymentRequestUniqeid = (uniqeid: string, tenantId: string) => {
    return getFetch(`paymentRequest/GetPaymentRequestByUniqid?uniqeid=${uniqeid}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}